import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { CartProvider } from "@/context/CartContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Boutique from "@/pages/Boutique";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderConfirmed from "@/pages/OrderConfirmed";
import Histoire from "@/pages/Histoire";
import Ethique from "@/pages/Ethique";
import Ingredients from "@/pages/Ingredients";
import Cooperatives from "@/pages/Cooperatives";
import Contact from "@/pages/Contact";
import Faq from "@/pages/Faq";
import Livraison from "@/pages/Livraison";
import Fidelite from "@/pages/Fidelite";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import OrderTracking from "@/pages/OrderTracking";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

// Admin
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/components/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminPromos from "@/pages/admin/AdminPromos";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminContent from "@/pages/admin/AdminContent";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminMessages from "@/pages/admin/AdminMessages";

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <LanguageProvider>
          <CartProvider>
            <BrowserRouter>
              <Routes>
                {/* Public */}
                <Route element={<Layout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/collections/all" element={<Boutique />} />
                  <Route path="/products/:slug" element={<ProductDetail />} />
                  <Route path="/panier" element={<Cart />} />
                  <Route path="/cart" element={<Navigate to="/panier" replace />} />
                  <Route path="/commande" element={<Checkout />} />
                  <Route path="/commande/confirmee" element={<OrderConfirmed />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<BlogPost />} />
                  <Route path="/pages/notre-histoire" element={<Histoire />} />
                  <Route path="/pages/notre-ethique" element={<Ethique />} />
                  <Route path="/pages/nos-ingredients" element={<Ingredients />} />
                  <Route path="/pages/nos-cooperatives" element={<Cooperatives />} />
                  <Route path="/pages/contact" element={<Contact />} />
                  <Route path="/pages/faq" element={<Faq />} />
                  <Route path="/pages/livraison" element={<Livraison />} />
                  <Route path="/pages/suivi-commande" element={<OrderTracking />} />
                  <Route path="/pages/programme-fidelite" element={<Fidelite />} />
                  <Route path="/pages/mentions-legales" element={<Legal />} />
                  <Route path="/pages/confidentialite" element={<Legal />} />
                  <Route path="/pages/cgu" element={<Legal />} />
                  <Route path="/pages/cookies" element={<Legal />} />
                  <Route path="*" element={<NotFound />} />
                </Route>

                {/* Admin */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route element={<AdminLayout />}>
                  <Route path="/admin" element={<AdminDashboard />} />
                  <Route path="/admin_dashboard" element={<AdminDashboard />} />
                  <Route path="/admin/produits" element={<AdminProducts />} />
                  <Route path="/admin/promotions" element={<AdminPromos />} />
                  <Route path="/admin/blog" element={<AdminBlog />} />
                  <Route path="/admin/contenu" element={<AdminContent />} />
                  <Route path="/admin/commandes" element={<AdminOrders />} />
                  <Route path="/admin/messages" element={<AdminMessages />} />
                </Route>
              </Routes>
            </BrowserRouter>
          </CartProvider>
        </LanguageProvider>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
